export const BOTTOM_NAV_HEIGHT = 56;
export const ADMIN_NAV_HEIGHT = 67;
export const STAFF_ACTION_BAR_HEIGHT = 64;
